import { render, staticRenderFns } from "./AircraftPeopleBtn.vue?vue&type=template&id=00e2a13a&scoped=true&"
import script from "./AircraftPeopleBtn.vue?vue&type=script&lang=js&"
export * from "./AircraftPeopleBtn.vue?vue&type=script&lang=js&"
import style0 from "./AircraftPeopleBtn.vue?vue&type=style&index=0&id=00e2a13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e2a13a",
  null
  
)

export default component.exports